import Aos from "../components/aos";
/**
 * 404 Page
 */
const Page404 = ($) => {
	if ($("body").hasClass("error404")) {
		Aos();
	}
};

export default Page404;
